/* v8 ignore start */
if (!Set.prototype.difference) {
  //eslint-disable-next-line no-extend-native
  Set.prototype.difference = function (otherSet) {
    if (!(otherSet instanceof Set)) {
      throw new TypeError('Argument must be a Set object');
    }
    const newSet = new Set();
    for (const item of this) {
      if (!otherSet.has(item)) {
        newSet.add(item);
      }
    }
    return newSet;
  };
}
/* v8 ignore stop */
